// Mobile-only infinite loop for the product media slider.
// Clones a few slides onto each end of the list and, once scrolling settles
// on a clone, silently jumps to the matching real slide.
if (!customElements.get('infinite-gallery-slider')) {
  const BaseSlider = customElements.get('slider-component');

  customElements.define('infinite-gallery-slider', class InfiniteGallerySlider extends BaseSlider {
    constructor() {
      super();
      if (!this.slider) return;

      this.cloneCount = 0;
      this.realCount = 0;
      this.isTouching = false;
      this.mql = window.matchMedia('(max-width: 749px)');

      this.onScrollSettled = this.onScrollSettled.bind(this);
      this.slider.addEventListener('scroll', () => {
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(this.onScrollSettled, 120);
      }, { passive: true });
      this.slider.addEventListener('touchstart', () => { this.isTouching = true; }, { passive: true });
      this.slider.addEventListener('touchend', () => {
        this.isTouching = false;
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(this.onScrollSettled, 120);
      }, { passive: true });

      this.mql.addEventListener('change', () => this.setupLoop());
      this.setupLoop();
      // Slides may have no width yet if stylesheets are still loading
      if (!this.cloneCount) window.addEventListener('load', () => this.setupLoop(), { once: true });
    }

    get realSlides() {
      return Array.from(this.slider.querySelectorAll('[id^="Slide-"]')).filter((slide) => slide.clientWidth > 0);
    }

    setupLoop() {
      this.removeClones();
      this.enableSliderLooping = false;
      if (!this.mql.matches) return this.initPages();

      const slides = this.realSlides;
      if (slides.length < 2) return this.initPages();

      this.realCount = slides.length;
      this.cloneCount = Math.min(slides.length, 3);
      this.enableSliderLooping = true;

      slides.slice(-this.cloneCount).reverse().forEach((slide) => this.slider.prepend(this.createClone(slide)));
      slides.slice(0, this.cloneCount).forEach((slide) => this.slider.append(this.createClone(slide)));

      this.initPages();
      this.jumpTo(this.cloneCount * this.sliderItemOffset);
    }

    createClone(slide) {
      const clone = slide.cloneNode(true);
      clone.removeAttribute('id');
      clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
      clone.classList.remove('is-active', 'product__media-item--variant');
      clone.classList.add('slider__slide--clone');
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('inert', '');
      return clone;
    }

    removeClones() {
      this.slider.querySelectorAll('.slider__slide--clone').forEach((clone) => clone.remove());
      this.cloneCount = 0;
    }

    // media-gallery.js calls this after prepending the variant's media
    resetPages() {
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      if (this.mql && this.mql.matches) return this.setupLoop();
      this.initPages();
    }

    jumpTo(left) {
      this.slider.style.scrollBehavior = 'auto';
      this.slider.scrollLeft = left;
      this.slider.style.scrollBehavior = '';
    }

    onScrollSettled() {
      if (!this.cloneCount || this.isTouching || !this.sliderItemOffset) return;

      const index = Math.round(this.slider.scrollLeft / this.sliderItemOffset);
      if (index < this.cloneCount) {
        this.jumpTo(this.slider.scrollLeft + this.realCount * this.sliderItemOffset);
      } else if (index >= this.cloneCount + this.realCount) {
        this.jumpTo(this.slider.scrollLeft - this.realCount * this.sliderItemOffset);
      }
    }

    update() {
      if (!this.cloneCount) return super.update();

      const previousPage = this.currentPage;
      const index = Math.round(this.slider.scrollLeft / this.sliderItemOffset) - this.cloneCount;
      this.currentPage = ((index % this.realCount) + this.realCount) % this.realCount + 1;

      if (this.currentPageElement && this.pageTotalElement) {
        this.currentPageElement.textContent = this.currentPage;
        this.pageTotalElement.textContent = this.realCount;
      }

      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }}));
      }

      this.prevButton.removeAttribute('disabled');
      this.nextButton.removeAttribute('disabled');
    }
  });
}
